import { GridCell, PedigreeEntry } from './types';

export function getGenerationLabel(depth: number): string {
  if (depth === 0) return 'Subject';
  if (depth === 1) return 'Sires and dams';
  if (depth === 2) return 'Grandsires and granddams';
  return `Generation ${depth}`;
}

/** Generations from subject (leaf = 1). Drives column count + "show more" toggle. */
export function getTreeDepth(entry: PedigreeEntry): number {
  const sireDepth = entry.sire ? getTreeDepth(entry.sire) : 0;
  const damDepth = entry.dam ? getTreeDepth(entry.dam) : 0;
  return 1 + Math.max(sireDepth, damDepth);
}

/**
 * Emits one GridCell per slot (incl. nulls for missing ancestors). Each cell
 * at depth d spans 2^(maxDepth-1-d) rows; children split that range in half.
 */
export function buildGridCells(
  root: PedigreeEntry,
  maxDepth: number,
): GridCell[] {
  const totalRows = Math.pow(2, maxDepth - 1);
  const cells: GridCell[] = [];

  function traverse(
    node: PedigreeEntry | null,
    depth: number,
    startRow: number,
    rowSpan: number,
    isSireLine: boolean,
    path: string,
  ) {
    cells.push({
      node,
      col: depth + 1,
      row: startRow,
      rowSpan,
      isSireLine,
      depth,
      path,
    });
    if (depth < maxDepth - 1) {
      const half = rowSpan / 2;
      traverse(node?.sire ?? null, depth + 1, startRow, half, true, `${path}s`);
      traverse(
        node?.dam ?? null,
        depth + 1,
        startRow + half,
        half,
        false,
        `${path}d`,
      );
    }
  }

  traverse(root, 0, 1, totalRows, true, '');
  return cells;
}
